// ticket.bets.[i].status
const betStatus = {
    Cancelled: 'Cancelled',
    CancelledBet: 'CancelledBet',
    Lost: 'Lost',
    Registered: 'Registered',
    Returned: 'Returned',
    Won: 'Won'
};
export const { Cancelled, CancelledBet, Lost, Registered, Returned, Won } = betStatus;
export default betStatus;
